import { Accordion } from "./Accordion";

type Props = {
    filterOptions: { value: string, isSelected: boolean, name: string, keyWordTitle: string }[];
    handleChooseFilter: (item: { value: string, isSelected: boolean }, isMultiSelect?: boolean) => () => void
}

export const CannabisGeneticFilter: React.FC<Props> = ({ filterOptions, handleChooseFilter }) => {
    const order = ['all', 'indica', 'sativa', 'hybrid'];
    const sortedOptions = [...filterOptions].sort(
        (a, b) => order.indexOf(a.value) - order.indexOf(b.value)
    );
    const isMobile = window.innerWidth < 768;
    const mobileStyleAttributes = { paddingBlock: "7px", borderRadius: "8px" };


    return (
        <Accordion title={filterOptions[0].keyWordTitle}>
            <div
                id="choose-treatment-genetic-filter"
                className="flex gap-2 py-2 md:py-4"
            >
                {sortedOptions.map((item, idx) => (
                    <div
                        key={idx}
                        id={`filter_${item.value}_${idx}`}
                        className="
                            capitalize
                            flex-1
                            text-center
                            cursor-pointer
                            py-3
                            transition-all
                            duration-300
                        "
                        onClick={handleChooseFilter(item, false)}
                        style={{ 
                            border: "1px solid", 
                            borderColor: "#DBE1EB", 
                            borderRadius: "15px", 
                            ...(item.isSelected ? { 
                                backgroundColor: "#269C6E", 
                                color: "white", 
                                fontWeight: "700", 
                                borderColor: "#269C6E" 
                            } : {}),
                            ...(isMobile ? mobileStyleAttributes : {})
                         }}
                    >
                        {item.name}
                    </div>
                ))}
            </div>
        </Accordion>

    );
};